import { render, staticRenderFns } from "./TreatmentFilter.vue?vue&type=template&id=6fb08053"
import script from "./TreatmentFilter.vue?vue&type=script&lang=js"
export * from "./TreatmentFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports